import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  get_NullableIntAdapter1poaa869odci7 as get_NullableIntAdapter,
  get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter,
  nullable1in0t8o94jx9t as nullable,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_getInstancehtoztkmjh1bx as Companion_getInstance } from '../GraphQLFloat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from '../SavePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyInput_InputAdapterClass;
function SavePartyInput_InputAdapter() {
  if (SavePartyInput_InputAdapterClass === VOID) {
    class $ {
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Input type used in output position');
      }
      toJson_wxdns7_k$(writer, customScalarAdapters, value) {
        writer.name_i73qwh_k$('partyId');
        get_partyIdAdapter().toJson_h31rt1_k$(writer, customScalarAdapters, value.partyId_1);
        var tmp = value.name_1;
        if (tmp instanceof Present()) {
          writer.name_i73qwh_k$('name');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.name_1);
        }
        var tmp_0 = value.email_1;
        if (tmp_0 instanceof Present()) {
          writer.name_i73qwh_k$('email');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.email_1);
        }
        var tmp_1 = value.pairingRule_1;
        if (tmp_1 instanceof Present()) {
          writer.name_i73qwh_k$('pairingRule');
          present(get_NullableIntAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.pairingRule_1);
        }
        var tmp_2 = value.badgesEnabled_1;
        if (tmp_2 instanceof Present()) {
          writer.name_i73qwh_k$('badgesEnabled');
          present(get_NullableBooleanAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.badgesEnabled_1);
        }
        var tmp_3 = value.defaultBadgeName_1;
        if (tmp_3 instanceof Present()) {
          writer.name_i73qwh_k$('defaultBadgeName');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.defaultBadgeName_1);
        }
        var tmp_4 = value.alternateBadgeName_1;
        if (tmp_4 instanceof Present()) {
          writer.name_i73qwh_k$('alternateBadgeName');
          present(get_NullableStringAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.alternateBadgeName_1);
        }
        var tmp_5 = value.callSignsEnabled_1;
        if (tmp_5 instanceof Present()) {
          writer.name_i73qwh_k$('callSignsEnabled');
          present(get_NullableBooleanAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.callSignsEnabled_1);
        }
        var tmp_6 = value.animationsEnabled_1;
        if (tmp_6 instanceof Present()) {
          writer.name_i73qwh_k$('animationsEnabled');
          present(get_NullableBooleanAdapter()).toJson_fhp2jo_k$(writer, customScalarAdapters, value.animationsEnabled_1);
        }
        var tmp_7 = value.animationSpeed_1;
        if (tmp_7 instanceof Present()) {
          writer.name_i73qwh_k$('animationSpeed');
          present(nullable(customScalarAdapters.responseAdapterFor_aqz4z4_k$(Companion_getInstance().type_1))).toJson_fhp2jo_k$(writer, customScalarAdapters, value.animationSpeed_1);
        }
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_wxdns7_k$(writer, customScalarAdapters, value instanceof SavePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePartyInput_InputAdapterClass = $;
  }
  return SavePartyInput_InputAdapterClass;
}
var SavePartyInput_InputAdapter_instance;
function SavePartyInput_InputAdapter_getInstance() {
  return SavePartyInput_InputAdapter_instance;
}
//region block: init
SavePartyInput_InputAdapter_instance = new (SavePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePartyInput_InputAdapter_instance as SavePartyInput_InputAdapter_instance2d93hz34kf5lo,
};
//endregion

//# sourceMappingURL=SavePartyInput_InputAdapter.mjs.map
